import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import App from './App.vue'
import router from "./router/index"

const app = createApp(App);
app.use(router).use(Antd).mount('#app');
